export default __webpack_public_path__ + "static/media/STEEL.349d5211.png";